
/** A url query value. `boolean`/`null` are here because callers pass them;
 *  `URLSearchParams` stringifies whatever survives the falsy check. */
type RouteParamValue = string | number | boolean | null | undefined;

interface DeviceAdminUpdateData {
  id?: RouteParamValue;
  org?: RouteParamValue;
  orgId?: RouteParamValue;
  type?: RouteParamValue;
  [key: string]: RouteParamValue;
}

interface DeviceAdminRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getUpdatePage: (data: DeviceAdminUpdateData) => string;
}

const _deviceAdminRoute: DeviceAdminRoute = {
  page: "/trackers",
  updatePage: "/trackers_admin_update",
  createPage: "",
  getUpdatePage: (data) => {
    const params = { ...data, org: data.org || data.orgId };
    // An absent org must be ABSENT, not the string "undefined" — otherwise the
    // level cannot be filled in below and the url reads as a junk slice.
    if (!params.org) delete params.org;
    delete params.orgId;
    // Paths only — the LEVEL is the caller's job, through `withOrg`. This used
    // to call `withOrgLevel`, a non-hook twin that read `window.location`, so a
    // route helper silently decided something the caller could see better. The
    // record's own organisation still comes from the caller.
    return `/trackers_admin_update?${new URLSearchParams(
      params as Record<string, string>
    ).toString()}`;
  },
};

export default _deviceAdminRoute;
